export default "__VITE_ASSET__jtFvutUj__"